import React from 'react'
import { COMBO_URL } from 'config/vars'
import { getCookie } from 'utils/cookies'
import { ROOT_PATH } from 'routes/paths'
import Url, { getQueryVariable } from 'utils/url'
import { criarUrlWithState } from 'components/modular/tabs-home/constants'
import { CRIAR_CLIENT_ID } from './constants'
import { useHistory } from 'react-router-dom'
import useLogin from './Login.hooks'
import DefaultLogin from './default-login'
import { usePublicFeatureToggles } from 'utils/hooks/use-public-feature-toggles'
import SpinnerLoader from 'components/loader'
import { useTranslation } from 'i18n'
import usePageTitle from 'utils/hooks/use-page-title'

const Login = () => {
  const { t } = useTranslation()

  usePageTitle(t('Entrar'))

  const ROUTE_AFTER_LOGGED_IN = getQueryVariable('redirectTo')
    ? decodeURIComponent(getQueryVariable('redirectTo') as string)
    : ROOT_PATH

  //Logic to validate whether the redirectURL prop is from "CRIAR" for redirection with authentication to the "CRIAR" platform
  const stateFromURL =
    getQueryVariable('state') && encodeURIComponent(getQueryVariable('state'))
  const clientId = decodeURIComponent(getQueryVariable('client_id') as string)
  const isCriarRedirect = clientId === CRIAR_CLIENT_ID

  const { comboRedirects, loading: comboRedirectsLoading } =
    usePublicFeatureToggles()

  const {
    localInfosChecked,
    currentStep,
    userName,
    currentLogin,
    password,
    loading,
    loginError,
    passwordError,
    handleLoginChange,
    handlePasswordChange,
    handleInitialFormSubmit,
    handleLoginWithPassword,
    handleNotMe
  } = useLogin({
    ROUTE_AFTER_LOGGED_IN,
    stateFromURL,
    clientId,
    isCriarRedirect
  })

  const history = useHistory()

  const isLogged =
    getCookie('access_token') !== null && getCookie('access_token') !== ''

  if (isLogged) {
    if (isCriarRedirect) {
      Url.set(criarUrlWithState(clientId, stateFromURL))
      return null
    } else {
      history.replace(ROUTE_AFTER_LOGGED_IN)
      return null
    }
  }

  //this logic was created because the login was being done by the combo, and is temporary since we are going to transfer the combo's login to the tree
  if (comboRedirects && !isCriarRedirect) {
    const KNOWN_BRANDS = ['biblion', 'superautor']
    const platform = KNOWN_BRANDS.includes(clientId) ? clientId : 'arvore'
    global.location.href = `${COMBO_URL}/login?platform=${platform}&redirectTo=${encodeURIComponent(
      ROUTE_AFTER_LOGGED_IN
    )}`
    return null
  }

  if (comboRedirectsLoading)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <SpinnerLoader />
      </div>
    )

  return (
    <DefaultLogin
      handleNotMe={() => handleNotMe()}
      loginRequiresPassword={currentStep === 'IdentifiedUser'}
      localInfosChecked={localInfosChecked}
      userName={userName}
      loginValue={currentLogin}
      passwordValue={password}
      loading={loading}
      loginError={loginError}
      passwordError={passwordError}
      handleLoginChange={event => handleLoginChange(event)}
      handlePasswordChange={event => handlePasswordChange(event)}
      handleLoginSubmit={handleInitialFormSubmit.bind(this)}
      handlePasswordSubmit={handleLoginWithPassword.bind(this)}
    />
  )
}

export default Login
